import PropTypes from 'prop-types'
import { useTheme } from '@mui/material'

export const LogoSymbol = (props) => {
  const { color } = props
  const theme = useTheme()
  const defaultColor = color || theme.palette.primary.main

  return (
    <svg
      width='50'
      height='48'
      viewBox='0 0 342 330'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M135.639 0C135.639 38.3019 166.688 69.3503 204.99 69.3506V69.3516C166.688 69.3519 135.639 100.402 135.639 138.704V138.705H135.638V138.704C135.637 100.701 105.07 69.8373 67.1807 69.3574L66.2852 69.3516C104.587 69.3512 135.637 38.3019 135.638 0H135.639Z'
        fill='url(#paint0_linear_1278_51026)'
      />
      <path
        d='M316.801 90.57C336.999 110.768 336.999 143.515 316.801 163.713L208 272.514L208.066 272.579L173.913 306.79C152.354 328.385 117.374 328.43 95.7592 306.89L61.3289 272.579L61.3947 272.512L24.8836 236.002C4.60147 215.72 4.60126 182.836 24.8832 162.554C45.1085 142.329 77.8801 142.265 98.185 162.41L135.622 199.553L243.499 90.73C263.671 70.3815 296.541 70.3098 316.801 90.57Z'
        fill='url(#paint1_linear_1278_51026)'
      />
      <path
        d='M316.797 90.57C336.995 110.768 336.995 143.515 316.797 163.713L207.996 272.514L208.062 272.579L203.387 277.262C173.131 307.57 121.39 293.454 110.717 251.98L105.418 231.392L135.618 199.553L243.495 90.7301C263.666 70.3816 296.537 70.3098 316.797 90.57Z'
        fill={defaultColor}
      />
      <path
        d='M169.091 233.529C189.541 253.978 222.02 255.055 243.742 236.769L207.997 272.515L208.063 272.581L173.91 306.792C152.35 328.387 117.371 328.431 95.7562 306.891L61.3261 272.581L61.3919 272.513L26.5703 237.692C48.2863 256.677 81.4069 254.272 102.149 233.529L135.619 199.555L169.091 233.529Z'
        fill={defaultColor}
      />
      <defs>
        <linearGradient id='paint0_linear_1278_51026' x1='192.166' y1='62.5452' x2='102.378' y2='149.617' gradientUnits='userSpaceOnUse'>
          <stop stop-color='white' />
          <stop offset='1' stop-color='#C8E1FF' />
        </linearGradient>
        <linearGradient id='paint1_linear_1278_51026' x1='24.5665' y1='163.026' x2='212.323' y2='279.448' gradientUnits='userSpaceOnUse'>
          <stop stop-color='white' />
          <stop offset='1' stop-color='#7CB8FF' />
        </linearGradient>
      </defs>
    </svg>
  )
}

LogoSymbol.propTypes = {
  color: PropTypes.string
}
